export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
    'React',
    // 'Docker',
    // 'Next JS',
    'Node JS',
    'Bootstrap',
    // 'Typescript',
    'MongoDB',
    'Tailwind',
    'MySQL',
    // 'PostgreSQL',
    'MaterialUI',
    // 'Firebase'
]


